module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_9005.a4125b94.png";